<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="font-size: 14px;">
                <div >
                    <div style="width: 70px">支持剂型：</div>
                </div>
                <div>
                    <div>
                        <el-checkbox v-model="particle">中药颗粒</el-checkbox>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);">支持规格：</span>
                        <el-checkbox-group v-model="assemble" @change="getCheck">
                            <el-checkbox label="KE">克</el-checkbox>
                            <el-checkbox label="DAI">袋</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="border:dashed #CCCCCC;border-width:0 0 1px 0;width: 1400px;margin-bottom: 10px"></div>
                    <div>
                        <el-checkbox v-model="slices">中药饮片</el-checkbox>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);">代煎服务：</span>
                        <el-checkbox-group v-model="replace">
                            <el-checkbox label="代煎"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);margin-top: 5px">代煎费用：</span>
                        <el-input style="width: 64px;" size="small"></el-input>
                        <span style="color: rgba(102,102,102,1);margin: 5px 10px">元/每剂</span>
                    </div>
                    <div style="border:dashed #CCCCCC;border-width:0 0 1px 0;width:1400px;margin-bottom: 10px"></div>
                    <div style="margin-top: 20px">
                        <el-button style="width: 96px">取消修改</el-button>
                        <el-button style="width: 68px;" type="primary">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                particle: '',
                assemble: [],
                slices: '',
                replace: [],
                cost: '',
            }
        },
        methods: {
            // 获取列表数据
            getData() {

            },
            getCheck(val) {
                console.log(val)
            },
            saveSet() {
                let params = {
                    pharmacyId:"111",
                    unit:"KE",
                    medicineTypeSet:["ZYKL","ZYWJ"],
                    isServer:0,
                    workMoney:2.30
                }
            },
        },
        watch: {

        },
        created() {
            this.getData()
        }
    }
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 12px;
        height: 52px;
    }

</style>